import React, { useEffect, useState } from "react";
import { Col, Row } from "antd";
import { useAsyncAxios, utilAxiosWithAppToken, utilAxiosWithAuth } from "../../utils/customAxios";

import * as Request from "../../commons/request";
import * as TypeDTO from "../../commons/typeDTO";

import TravelSpotCard from "../../component/rent/TravelSpotCard";
import Banner from "../../assets/images/home/ruta40/banner_travelGuide.jpg";

function TravelSpot() {
    const [originPlaces, setOriginPlaces] = useState<Array<TypeDTO.RentTravelSpotDto>>([]);

    const requestAxiosGetTravelSpots = async () => {
        const response = await utilAxiosWithAppToken().get(Request.RENT_TRAVEL_SPOTS_URL);
        return response.data;
    };

    const {
        loading: loadingGetTravelSpots,
        error: errorGetTravelSpots,
        data: resultGetTravelSpots,
        execute: requestGetTravelSpots,
    } = useAsyncAxios(requestAxiosGetTravelSpots);

    useEffect(() => {
        requestGetTravelSpots();
    }, []);

    useEffect(() => {
        if (!resultGetTravelSpots) return;

        const originSpots: Array<TypeDTO.RentTravelSpotDto> = resultGetTravelSpots.travelSpots;
        setOriginPlaces(originSpots);
    }, [loadingGetTravelSpots]);

    return (
        <div style={{ minHeight: "calc(100vh - 70px)" }}>
            <div className="header-container model">
                <div className="container" style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.2),rgba(0, 0, 0, 0.2)),url(${Banner})` }}>
                    <div className="row justify-content-center">
                        <div className="fadeIn text-center mb-5">
                            <h5 className="text-center text-light px-3 mb-4">추천 여행지</h5>
                            <h1 className="text-light">TRAVEL SPOT</h1>
                        </div>
                    </div>
                </div>
            </div>
            <div className="model-tabs title model-body" style={{ backgroundColor: "white" }}>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 22, offset: 1 }}
                    lg={{ span: 18, offset: 3 }}
                    xl={{ span: 16, offset: 4 }}
                    xxl={{ span: 14, offset: 5 }}
                    className="fadeInUp p-4"
                >
                    <Row gutter={32}>
                        {originPlaces.map((place, index) => {
                            return (
                                <Col sm={{ span: 24 }} lg={{ span: 8 }} key={index} className={`mb-5 w-100`}>
                                    <TravelSpotCard place={place} />
                                </Col>
                            );
                        })}
                    </Row>
                </Col>
            </div>
        </div>
    );
}

export default TravelSpot;
